export default __webpack_public_path__ + "static/media/times-1.4df82aee.svg";